import { faRotateLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ActionIcon, Tooltip } from '@mantine/core';
import { useTranslation } from 'react-i18next';

type TaskUndoActionPropsType = {
  onReopen: () => void;
};

export const TaskUndoAction: React.FC<TaskUndoActionPropsType> = ({
  onReopen,
}) => {
  const { t } = useTranslation('tasks');
  const label = t('ACTIONS.UNDO');

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    event.stopPropagation();
    onReopen();
  };

  return (
    <Tooltip label={label}>
      <ActionIcon
        size="sm"
        color="gray"
        variant="subtle"
        onClick={handleClick}
        aria-label={label}
      >
        <FontAwesomeIcon
          icon={faRotateLeft}
          size="sm"
          color="var(--mantine-color-text-4)"
        />
      </ActionIcon>
    </Tooltip>
  );
};
